import type { Scheduling, SellingMode, TariffGroupAttribute } from '@src/core/buyerApiClient';
import { mountTariffsPerTypeListFromSchedulings } from '@src/domains/tariffs';
import type { TariffsState } from '@src/stores/product';

import { resolveSchedulingsForAttributes } from '@src/domains/products/scheduleHours/core/filterSchedulingsByAttributes';
import type { SelectedProductAttribute } from '@src/domains/products/features/product-booking/types/attribute';

export const applyTariffsForDateAndAttributes = (
  sellingMode: SellingMode,
  tariffsState: TariffsState,
  schedulings: Scheduling[],
  attributes: TariffGroupAttribute[],
  selectedAttributes: SelectedProductAttribute[],
  minSaleTariffQuantities: number,
): void => {
  const resolved = resolveSchedulingsForAttributes(schedulings, attributes, selectedAttributes);

  tariffsState.listOfTariffsPerType = mountTariffsPerTypeListFromSchedulings(
    sellingMode,
    resolved,
    minSaleTariffQuantities,
  );
};
